import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { PropagateLoader } from "react-spinners";
import Heading from "../../../components/atoms/Heading";
import DFTemplate from "../../../components/templates/clientes/DF/DFTemplate"
import { GET_ENTERPRISE_BY_USER } from "../../../api/apiEmpresas";
import { useSession } from "../../../context/SessionContext";

const DF = () => {
    const params = useParams();
    const { id } = params;
    const { user } = useSession();
    const [empresaValida, setEmpresaValida] = useState(false);
    const [loading, setLoading] = useState(true);

    const checkEmpresaValida = useCallback(async () => {
        const empresaId = Number(id);

        const hasEmpresa = (empresas) =>
            empresas?.some((empresa) => empresa?.id === empresaId);

        try {
            if (!user) return;

            switch (user.role) {
                case "Client": {
                    const empresas = await GET_ENTERPRISE_BY_USER(user.id);
                    return setEmpresaValida(hasEmpresa(empresas));
                }
                case "Admin": {
                    if (user.roleInfo?.isSuperAdmin) {
                        return setEmpresaValida(true);
                    }
                    return setEmpresaValida(false);
                }
                case "Lawyer": {
                    return setEmpresaValida(true);
                }
                default:
                    return setEmpresaValida(false);
            }
        } catch (error) {
            console.error("Error al validar empresa:", error);
        } finally {
            setLoading(false);
        }
    }, [user, id]);

    useEffect(() => {
        checkEmpresaValida();
    }, [checkEmpresaValida]);

    return(
        <div>
            {loading ?
                <div className="flex w-full h-full justify-center items-center">
                    <PropagateLoader color="red" />
                </div>
            :
                (!empresaValida ?
                    <div className="w-full h-full flex justify-center items-center">
                        <Heading text="Elige una empresa de tu dashboard" color="red" />
                    </div>
                :
                    <DFTemplate id={id} />
                )
            }
        </div>
    )
};

export default DF;